var React = require('react');

function Text (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.66797 4.66406V2.66406H13.3346V4.66406","stroke":"#130A09","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M6 13.3359H10","stroke":"#130A09","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M8 2.66406V13.3307","stroke":"#130A09","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Text.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Text;

Text.default = Text;
